import { IConfig } from '@cian/config/shared';

export const isDocumentUploadEnabled = (config: IConfig): boolean => {
  return Boolean(config.get<boolean>('frontend-chats.DocumentUpload.Enabled'));
};
